import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './homepage.component';
import { HomepageService } from './homepage.service';

const routes: Routes = [
  {
    path: '',
    data: { discriminantPathKey: 'HOMEPAGE' },
    component: HomepageComponent,
    resolve: {
      data: HomepageService,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomepageRoutingModule {}
